import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getEnabledLocales, localizePath, DEFAULT_LOCALE } from "@/i18n/helpers";
import { setMeta } from "@/i18n/dom";

/*
  Per-page <head>: title + description + og:title/description come from the
  active locale (English via fallback for now). Also manages hreflang alternate
  links for every enabled language + x-default, derived from the config.
*/
export default function usePageHead(page) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  useEffect(() => {
    const title = t(`${page}.meta.title`);
    const desc = t(`${page}.meta.description`);
    document.title = title;
    setMeta({ name: "description" }, desc);
    setMeta({ property: "og:title" }, title);
    setMeta({ property: "og:description" }, desc);

    // Refresh managed hreflang alternates.
    document.querySelectorAll("link[data-i18n-alt]").forEach((n) => n.remove());
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const add = (hreflang, href) => {
      const link = document.createElement("link");
      link.setAttribute("rel", "alternate");
      link.setAttribute("hreflang", hreflang);
      link.setAttribute("href", href);
      link.setAttribute("data-i18n-alt", "true");
      document.head.appendChild(link);
    };
    getEnabledLocales().forEach((l) =>
      add(l.code, origin + localizePath(page, l.code))
    );
    add("x-default", origin + localizePath(page, DEFAULT_LOCALE));
  }, [t, lang, page]);
}
